import { useEffect, useState } from 'react'

// Match olo-demo thresholds: compact engages at 48px, releases at 16px (hysteresis prevents flicker)
const COMPACT_ON_PX = 48
const COMPACT_OFF_PX = 16

export function useScrollCompact(): boolean {
	const [isCompact, setIsCompact] = useState(false)

	useEffect(() => {
		function handleScroll() {
			const y = window.scrollY
			setIsCompact((prev) => {
				if (!prev && y >= COMPACT_ON_PX) return true
				if (prev && y <= COMPACT_OFF_PX) return false
				return prev
			})
		}

		window.addEventListener('scroll', handleScroll, { passive: true })
		// Sync on mount in case the page is already scrolled (e.g. back navigation)
		handleScroll()
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	return isCompact
}
